<template>
    <div class="inline-block">
        <div v-if="formOpen === false">
            <AppButton element="button" type="button" @click="open()" class="flex items-center space-x-2">
                <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
                {{ $tc('messages.fields', 1) }}
            </AppButton>
        </div>
        <template v-else>
            <Modal :show="formOpen" @close="formOpen = false">
                <form :action="endpoint.url" method="post" @submit.prevent="submit">
                    <div class="md:grid md:grid-cols-3 md:gap-12">
                        <div class="sm:col-span-12">
                            <FormLabel :value="$tc('messages.fields', 1)" for="name" />
                            <FormInput
                                required
                                id="name"
                                v-model="form.name"
                                name="name"
                                ref="text"
                                type="text"
                                maxlength="180"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                        <div class="sm:col-span-12">
                            <div class="sm:col-span-12" v-for="(option, index) in form.options" :key="index">
                                <div class="mt-1">
                                    <FormLabel
                                        :value="$t('messages.option_X', { x: index + 1 })"
                                        :for="`option_${index}`"
                                    />
                                    <div class="flex justify-between items-center">
                                        <FormInput
                                            required
                                            :id="`option_${index}`"
                                            v-model="option.text"
                                            :name="`option_${index}`"
                                            type="text"
                                            max="191"
                                            class="mt-1 w-full"
                                        />
                                        <button
                                            type="button"
                                            @click="deleteOption(form.options, index)"
                                            v-show="index > 1"
                                            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                    clip-rule="evenodd"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <FormError :value="form.errors[`options.${index}.text`]" class="mt-2" />
                                </div>
                            </div>

                            <div v-show="form.options.length < 15" class="mt-3">
                                <PlusButton @click="addOption()" />
                            </div>
                        </div>
                    </div>
                    <div class="flex space-x-2 justify-end mt-5">
                        <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                            {{ $t('messages.save') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner" />
                        </AppButton>

                        <AppButton element="button" type="button" @click="formOpen = !formOpen">
                            {{ $t('messages.cancel') }}
                        </AppButton>
                    </div>
                </form>
            </Modal>
        </template>
    </div>
</template>

<script>
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AppButton from '@/components/AppButton.vue';
import Modal from '@/components/Modal.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';

export default {
    name: 'StudentFileFieldCreateModalForm',
    components: {
        FormLabel,
        FormInput,
        FormError,
        AppButton,
        PlusButton,
        Modal,
    },
    props: {
        endpoint: {
            type: Object,
            required: true,
        },
        text: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            formOpen: false,
            form: this.$inertia.form({
                name: '',
                options: [
                    {
                        text: this.$t('messages.yes'),
                    },
                    {
                        text: this.$t('messages.no'),
                    },
                ],
            }),
        };
    },
    methods: {
        submit() {
            this.form.submit(this.endpoint.method, this.endpoint.url, {
                onSuccess: () => {
                    this.form.reset('name', 'options');
                    this.formOpen = false;
                },
                preserveScroll: true,
            });
        },
        cancel() {
            this.formOpen = false;
            this.form.reset('name', 'options');
            this.form.clearErrors();
        },
        deleteOption(options, index) {
            options.splice(index, 1);
        },
        addOption() {
            this.form.options.push({
                text: '',
            });
        },
        open() {
            this.formOpen = true;
            this.focusInput();
        },
        focusInput() {
            this.$nextTick(function () {
                this.$refs.text.focusInput();
            });
        },
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
